import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { useFormikContext } from "formik";
import { mapValues } from "lodash";
/**
 * Makes form errors visible on all invalid fields on submit by making them touched.
 */
export const useSubmitValidateAll = () => {
    const { setErrors, setTouched, values, submitCount, validateForm } = useFormikContext();
    useEffect(() => {
        const validateAll = async () => {
            if (submitCount > 0) {
                const errors = await validateForm(values);
                if (errors) {
                    setErrors(errors);
                    setTouched(mapValues(errors, () => true));
                }
            }
        };
        validateAll();
    }, [values, submitCount, validateForm, setErrors, setTouched]);
};
export const FormikValidateAllOnSubmit = () => {
    useSubmitValidateAll();
    return _jsx(_Fragment, {});
};
